class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[type="submit"][name="add"]');
    this.errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.querySelector('.product-form__error-message');

    this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  async onSubmitHandler(event) {
    event.preventDefault();
    if (!this.form || this.submitButton?.getAttribute('aria-disabled') === 'true') return;

    this.handleErrorMessage();
    this.submitButton?.setAttribute('aria-disabled', 'true');
    this.submitButton?.classList.add('loading');

    const formData = new FormData(this.form);
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {
      formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
    }

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: formData,
      });
      const state = await response.json();

      if (!response.ok) {
        this.handleErrorMessage(state.description || state.message || window.cartStrings.error);
        return;
      }

      if (cartDrawer) {
        cartDrawer.renderContents(state);
      } else {
        window.location = window.routes.cart_url;
      }
    } catch (error) {
      this.handleErrorMessage(window.cartStrings.error);
    } finally {
      this.submitButton?.classList.remove('loading');
      this.submitButton?.removeAttribute('aria-disabled');
    }
  }

  handleErrorMessage(errorMessage = false) {
    if (!this.errorMessageWrapper) return;
    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    if (this.errorMessage) this.errorMessage.textContent = errorMessage || '';
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm);
}

if (!window.reggaeSpiceCartSubmitHandlerReady) {
  window.reggaeSpiceCartSubmitHandlerReady = true;

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || form.closest('product-form')) return;

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    event.preventDefault();

    const submitButton = form.querySelector('[type="submit"]');
    submitButton?.setAttribute('aria-disabled', 'true');

    const formData = new FormData(form);
    formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.section));
    formData.append('sections_url', window.location.pathname);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: formData,
    })
      .then((response) => response.json().then((state) => ({ ok: response.ok, state })))
      .then(({ ok, state }) => {
        if (!ok) throw new Error(state.description || state.message || window.cartStrings.error);
        cartDrawer.renderContents(state);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        submitButton?.removeAttribute('aria-disabled');
      });
  });
}
